import { emitter, EventType } from '@/utils/emitter.utils';
import { Shape } from '../shape';
import { Node } from 'konva/lib/Node';
import KonvaService from '.';
import { Attributes } from '../shape/attributes';
import { round } from 'lodash-es';
import { useRuntimeStore } from '@/store/use-runtime-store';
import { notification } from 'ant-design-vue';

export class KonvaTransform {
  /**
   *  变形中
   */
  static TRANSFORMING = false;

  private konvaService: KonvaService;
  constructor(konvaService: KonvaService) {
    this.konvaService = konvaService;
  }

  /**
   * 绑定大小拖拽，选择操作
   * @param shape
   */
  bindEvent(rect: Node) {
    const initData = {
      x: 0,
      y: 0,
      scaleX: 1,
      scaleY: 1
      // rotation: 0,
    };
    const shapeData = {
      x: 0,
      y: 0,
      w: 0,
      h: 0
    };

    let shape: Shape | undefined;
    rect.on('transformstart', (e) => {
      const target = e.target;
      const name = target.name();
      // 记录shape的初始位置
      shape = Shape.getShape(name);
      shapeData.x = shape?.attrs.x ?? 0;
      shapeData.y = shape?.attrs.y ?? 0;
      shapeData.w = target.width();
      shapeData.h = target.height();

      KonvaTransform.TRANSFORMING = true;

      // 记录拖拽那一刻的数据
      initData.x = target.position().x;
      initData.y = target.position().y;
      initData.scaleX = target.scaleX();
      initData.scaleY = target.scaleY();
    });

    const resizeOnTranforming = (target: Node) => {
      if (!shape) return;

      const scaleX = target.scaleX() / initData.scaleX;
      const scaleY = target.scaleY() / initData.scaleY;

      const w = shapeData.w * scaleX;
      const h = shapeData.h * scaleY;

      const isImageRotateEnabled = false;

      // const align = shape.attrs.align ?? 'left';
      const offsetX = isImageRotateEnabled ? -w / 2 : 0;
      const offsetY = isImageRotateEnabled ? -h / 2 : 0;
      let x = target.position().x + offsetX;
      let y = target.position().y + offsetY;
      const nodeData = target.getAttr?.('data') ?? {};
      const groupOffset = nodeData.progressBarGroupOffset as
        | { x: number; y: number }
        | undefined;
      if (groupOffset) {
        x += groupOffset.x;
        y += groupOffset.y;
      }
      const attrs: Partial<Attributes> = {
        x: Math.round(x),
        y: Math.round(y),
        w: Math.round(w),
        h: Math.round(h)
      };
      // 如果是可选择
      if (isImageRotateEnabled) {
        const rotation = round(target.rotation(), 1);
        attrs.rotation = rotation;
      }
      shape.setAttrs(attrs);
    };

    rect.on('transform', (e) => {
      KonvaTransform.TRANSFORMING = true;
      const target = e.target;
      resizeOnTranforming(target);
    });

    rect.on('transformend', () => {
      const shapeId = shape?.id;
      // 拖拽失败恢复：如果用户拉小到比 runtime 渲染尺寸还小，
      // 画布会通过 Math.max(runtime, attrs) 回弹，但 attrs.w 已被写入拉小的值。
      // 此时用 runtime 值修正 attrs，保持与画布显示一致。
      if (shape && shapeId) {
        const runtimeStore = useRuntimeStore();
        const state = runtimeStore.shapeState(shapeId);
        if (state?.width && state?.height) {
          const rw = Math.round(state.width);
          const rh = Math.round(state.height);
          const currentW = shape.attrs.w ?? 0;
          const currentH = shape.attrs.h ?? 0;
          if (currentW < rw || currentH < rh) {
            notification.warning({
              key: 'widget-size-clamp',
              message: '调整失败',
              description: `组的尺寸不能小于子元素实际渲染尺寸`
            });
            shape.setAttrs({
              w: Math.max(currentW, rw),
              h: Math.max(currentH, rh)
            });
          }
        }
      }
      setTimeout(() => {
        KonvaTransform.TRANSFORMING = false;
        emitter.emit(EventType['konva:transformed'], {
          shapeIds: [shapeId]
        });
      }, 0);
    });
  }
}
